import { Routes } from '@/router/routes'

import { AppPermissions } from '@/types/enums/permissions/permissions'
import { Middleware } from '@/types/enums/middleware/middleware'

export const holidayRequestsRoutes = [
  {
    path: '/holiday-requests',
    name: Routes.HolidayRequests,
    component: () => import('@/pages/contexts/portal/holiday-requests/Index.vue'),
    meta: {
      pageTitle: 'Manage Holiday Requests',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.MANAGE_HOLIDAY_REQUESTS,
    },
    children: [
      {
        path: 'edit/:holidayRequestId',
        name: Routes.HolidayRequestsEdit,
        component: () => import('@/pages/contexts/portal/holiday-requests/Edit.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_HOLIDAY_REQUESTS,
        },
      },
    ],
  },
]
